const BooleanInput = ({ value, onChange, onSelect, autoFocus = false }) => {
  const handleSelect = (boolValue) => {
    onChange(boolValue);
    if (onSelect) {
      onSelect(boolValue);
    }
  };

  return (
    <div className="relative inline-block">
      <select
        value={
          value === true || value === "true"
            ? "true"
            : value === false || value === "false"
              ? "false"
              : ""
        }
        onChange={(e) => handleSelect(e.target.value === "true")}
        className="px-3 py-1 border-0.5 border-gray-300 rounded text-sm focus:outline-none focus:ring-1 focus:ring-pink focus:border-transparent min-w-[100px] bg-white"
        autoFocus={autoFocus}
      >
        <option value="">Select...</option>
        <option value="true">True</option>
        <option value="false">False</option>
      </select>
    </div>
  );
};

export default BooleanInput;
